import { Button } from "@mui/material";
import { Link } from "react-router-dom";
import ReactGA from "react-ga4";

const Register = () => {
  return (
    <div className="home-contact-area signup-area">
      <div className="container">
        <div className="row">
            <div
              style={{
                display: "flex",
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                marginTop: 100
              }}
            >
              <Link 
                to="/registerProfesseur"
                onClick={() => ReactGA.event({ category: "Auth", action: "sign_up_start", label: "professeur" })}
              >
                <Button className="box-btn">Préinscription des professeurs</Button>
              </Link>
              <Link 
                to="/registerTuteur" 
                style={{marginTop: 40}}
                onClick={() => ReactGA.event({ category: "Auth", action: "sign_up_start", label: "tuteur" })}
              >
                <Button className="box-btn">Inscription des Tuteurs</Button>
              </Link>
            </div>
          </div>
      </div>
    </div>
  );
};

export default Register;
